import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartItem from "../../components/CartItem";
import NewAddressForm from "../../components/NewAddressForm";
import {
  removeCart,
  incCart,
  decCart,
  updateCartQuantity,
} from "../../store/actions/cart";
import { createNewOrderForCustomer } from "../../store/actions/order";
import { customerGetAddress } from "../../store/actions/customer";

import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";
import writeMethod from "../../helpers/writeMethod";
import CheckoutCart from "../../components/CheckoutCart";

class Checkout extends Component {
  state = {
    errors: [],
    address: null,
    payment: "Havale / EFT",
    comment: "",
  };
  constructor(props) {
    super(props);
    this.address = React.createRef();
    this.payment = React.createRef();
  }

  componentDidMount() {
    this.props.customerGetAddress((address) => {
      this.setState({ address });
    });
    window.scrollTo(0, this.address.current.offsetTop);
  }

  addNewAddressModal() {
    return <NewAddressForm />;
  }

  validate() {
    const errors = [];
    if (this.props.cart.items && this.props.cart.items.length === 0)
      errors.push("Siparişi onaylamak için sepetinizide ürün olmalıdır!");
    if (this.state.address === null)
      errors.push("Siparişi onaylamak için adres seçmelisiniz!");
    return errors;
  }

  sendOrder() {
    if (this.validate().length === 0) {
      this.setState({ errors: [] });

      this.props.createNewOrderForCustomer({
        ...this.state,
        setting: {
          shipping_cost: this.props.setting.setting.shipping_cost,
          free_shipping: this.props.setting.setting.free_shipping,
        },
        products: this.props.cart.items,
      });
    } else {
      this.setState({ errors: this.validate() });
    }
  }

  policyPages() {
    const membershipAgreement = this.props.page.page.find(
      ({ location }) => location === "membership_agreement"
    );

    const privacyPolicy = this.props.page.page.find(
      ({ location }) => location === "privacy_policy"
    );

    const distanceSalesContract = this.props.page.page.find(
      ({ location }) => location === "distance_sales_contract"
    );

    return (
      <React.Fragment>
        {membershipAgreement && (
          <div
            className="modal fade bd-example-modal-lg"
            id="membership_agreement"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {membershipAgreement.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{
                    __html: membershipAgreement.content,
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {privacyPolicy && (
          <div
            className="modal fade bd-example-modal-lg"
            id="privacy_policy"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {privacyPolicy.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{ __html: privacyPolicy.content }}
                />
              </div>
            </div>
          </div>
        )}

        {distanceSalesContract && (
          <div
            className="modal fade bd-example-modal-lg"
            id="distance_sales_contract"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {distanceSalesContract.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{
                    __html: distanceSalesContract.content,
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <PageTitle title={"Ödeme"} />
        {this.policyPages()}
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-12"}>
                <div
                  className={"row"}
                  style={{ marginTop: 10, marginBottom: 50 }}
                >
                  {/* <table className={styles.cartDetail}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>RESİM</th>
                        <th>ÜRÜN ADI</th>
                        <th className="product-price">BİRİM FİYATI</th>
                        <th>MİKTAR</th>
                        <th className="product-subtotal">TOPLAM</th>
                        <th className="product-remove">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.cart.items.map((item, i) => (
                        <CartItem
                          key={i}
                          product={item}
                          updateCartQuantity={quantity => {
                            this.props.updateCartQuantity(item, quantity);
                          }}
                          removeCart={() => {
                            this.props.removeCart(item);
                          }}
                          incCart={() => {
                            this.props.incCart(item);
                          }}
                          decCart={() => {
                            this.props.decCart(item);
                          }}
                        />
                      ))}
                    </tbody>
                  </table> */}
                  <div className={styles.payment} ref={this.address}>
                    <h3 style={{ marginTop: 20 }}>Adres Seçimi</h3>
                    <span>Teslimat adresinizi seçiniz</span>
                    {this.addNewAddressModal()}
                    {!this.props.customer.addressFetching ? (
                      <ul className={styles.addressesList}>
                        <li data-toggle="modal" data-target="#exampleModal">
                          <span>
                            <FontAwesomeIcon icon={["fas", "plus"]} />
                          </span>
                          Yeni Adres Ekle
                        </li>
                        {this.props.customer.addresses.map((address, i) => (
                          <li
                            key={i}
                            onClick={() => {
                              this.setState({ address: address.id }, () => {
                                window.scrollTo(
                                  0,
                                  this.payment.current.offsetTop
                                );
                              });
                            }}
                            className={
                              address.id === this.state.address ? "active" : ""
                            }
                          >
                            <div>
                              <strong>{address.address_name}</strong>-
                              <span className="name">{address.full_name}</span>
                            </div>
                            <div>{address.address}</div>
                            <div>
                              <strong>Tel:</strong>
                              {address.phone}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <Loading text={"Adresleriniz Yükleniyor..."} />
                    )}
                    <hr />
                  </div>

                  <div className={styles.payment} ref={this.payment}>
                    <h3>Ödeme Yöntemi</h3>
                    <span>
                      Siparişinizde kullanılacak ödeme yöntemini seçiniz.
                    </span>
                    <h6 style={{ color: "red" }}>
                      Ödeme seçenekleri arasında şu an için sadece Havale/EFT
                      bulunmaktadır. Diğer ödeme yöntemleri şu anda
                      kullanılamamaktadır.
                    </h6>
                    <div style={{ marginTop: 15 }}>
                      {this.props.setting.setting.payments.map(
                        ({ method, content }, i) => (
                          <React.Fragment key={i}>
                            <p>
                              <label className={styles.paymentCheckLabel}>
                                <input
                                  type="radio"
                                  name={"payment"}
                                  value={writeMethod(method)}
                                  checked={
                                    this.state.payment === writeMethod(method)
                                  }
                                  onChange={(e) => {
                                    this.setState({
                                      [e.target.name]: e.target.value,
                                    });
                                  }}
                                />
                                {` ${writeMethod(method)}`}
                              </label>
                            </p>

                            {this.state.payment === writeMethod(method) ? (
                              <div
                                dangerouslySetInnerHTML={{ __html: content }}
                              />
                            ) : null}
                          </React.Fragment>
                        )
                      )}
                      {/* <p>
                        <label className={styles.paymentCheckLabel}>
                          <input
                            type="radio"
                            name={"payment"}
                            value={"Kapıda Ödeme"}
                            checked={this.state.payment === "Kapıda Ödeme"}
                            onChange={e => {
                              this.setState({
                                [e.target.name]: e.target.value
                              });
                            }}
                          />{" "}
                          Kapıda Ödeme
                        </label>
                      </p>
                      {this.state.payment == "Kapıda Ödeme" ? null : null} */}
                      {/* <p>
                        <label className={styles.paymentCheckLabel}>
                          <input
                            type="radio"
                            name={"payment"}
                            value={"Havale / EFT"}
                            checked={this.state.payment === "Havale / EFT"}
                            onChange={e => {
                              this.setState({
                                [e.target.name]: e.target.value
                              });
                            }}
                          />{" "}
                          Havale / EFT ile Ödeme
                        </label>
                      </p>
                      {this.state.payment == "Havale / EFT" ? (
                        <div>
                          <p>
                            <strong>
                              Havale/EFT yaparken dikkat edilmesi gerekenler:
                            </strong>
                          </p>
                          <p>
                            Siparişinizin gecikmemesi için, Havale/EFT
                            işlemlerinde açıklama bölümüne sipariş numaranızı
                            girmeniz gerekmektedir.
                          </p>
                          <p>
                            (Sipariş Numaranız Alışverişiniz Tamamlandıktan
                            Sonra Oluşturulacaktır.) Ayrıca 7 gün içinde ödemesi
                            yapılmayan siparişler otomatik olarak silinmektedir.
                          </p>
                          <p>
                            <strong>
                              Hesap sahibinin adı ve soyadını yazmak
                              durumundaysanız aşağıdaki gibi yazabilirsiniz:
                            </strong>
                          </p>
                          <p>Alıcı Adı:NİHAT</p>
                          <p>Alıcı Soyadı: DÜZ</p>

                          <div
                            style={{
                              fontSize: 13,
                              borderRadius: 15,
                              padding: 10,
                              margin: "20px 0",
                              border: [1, "solid", "#ccc"],
                              background: "#ddd"
                            }}
                          >
                            <b>Banka Adı:</b>
                            <br />
                            HALKBANK<br />
                            <b>Hesap Sahibi:</b>
                            <br />
                            NİHAT DÜZ<br />
                            <b>Şube:</b>
                            <br />
                            Isparta Şubesi<br />
                            <b>Hesap No:</b>
                            <br />
                            0545 - 01054950<br />
                            <b>IBAN:</b>
                            <br />
                            TR39 0001 2009 5450 0001 0549 50
                          </div>
                        </div>
                      ) : null} */}
                    </div>
                    <CheckoutCart header={true} {...this.props} />

                    <div style={{ marginTop: 5 }}>
                      Siparişiniz hakkında bir açıklama ekleyebilirsiniz.
                      <br />
                      <textarea
                        className={"form-control"}
                        rows={3}
                        name={"comment"}
                        defaultValue={this.state.value}
                        onChange={(e) => {
                          this.setState({ [e.target.name]: e.target.value });
                        }}
                      />
                    </div>

                    <div>
                      <p style={{ fontSize: 12, color: "#555" }}>
                        **Siparişimi Onayla butonuna basarak{" "}
                        {this.props.page.page.findIndex(
                          ({ location }) =>
                            location === "distance_sales_contract"
                        ) >= 0 && (
                          <React.Fragment>
                            <a
                              href="#"
                              data-toggle="modal"
                              data-target="#distance_sales_contract"
                            >
                              Mesafeli Satış Sözleşmesi
                            </a>
                            ’ni,
                          </React.Fragment>
                        )}
                        {` `}
                        {this.props.page.page.findIndex(
                          ({ location }) => location === "privacy_policy"
                        ) >= 0 && (
                          <React.Fragment>
                            <a
                              href="#"
                              data-toggle="modal"
                              data-target="#privacy_policy"
                            >
                              Gizlilik ve Çerez Politikası
                            </a>
                            ’ni
                          </React.Fragment>
                        )}
                        {` `}okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.
                      </p>
                    </div>
                    {this.state.errors.length > 0 && (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        style={{
                          marginTop: 10,
                        }}
                      >
                        <ul
                          style={{
                            listStyle: "inherit",
                            marginLeft: 25,
                          }}
                        >
                          {this.state.errors.map((error, i) => (
                            <li key={i}>{error}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <button
                      style={{ marginTop: 10 }}
                      type="button"
                      disabled={
                        this.props.order.fetching ||
                        this.props.cart.items.length === 0
                      }
                      className={styles.buttonDefaultSM}
                      onClick={(e) => {
                        e.preventDefault();
                        this.sendOrder();
                      }}
                    >
                      {this.props.order.fetching ? (
                        <React.Fragment>
                          <FontAwesomeIcon icon="spinner" size={"lg"} spin />{" "}
                          Siparişiniz Onaylanıyor...
                        </React.Fragment>
                      ) : this.props.cart.items.length === 0 ? (
                        "Siparişi Onaylamak İçin Sepetinize Ürün Eklemelisiniz!"
                      ) : (
                        "Siparişi Onayla"
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className={"col-md-3"}>
                 <Widget title={"SİPARİŞ ÖZETİ_checkout"}>
                  <div className={styles.orderSummary}>
                    <ul>
                      <li>
                        <strong>
                          Toplam{" "}
                          {this.props.cart.items.length > 0
                            ? this.props.cart.items
                                .map((v) => v.quantity)
                                .reduce((a, b) => a + b)
                            : 0}{" "}
                          Ürün
                        </strong>
                      </li>
                      <li>
                        Ürün Toplamı
                        <span>
                          {" "}
                          ₺
                          {this.props.cart.items.length > 0
                            ? parseFloat(
                                this.props.cart.items
                                  .map((v) =>
                                    v.sale_price
                                      ? v.quantity * v.sale_price
                                      : v.quantity * v.price
                                  )
                                  .reduce((a, b) => a + b)
                                  .toFixed(2)
                              )
                            : 0}
                        </span>
                      </li>
                      <li className={"sperator"} />
                      <li>
                        Toplam
                        <span>
                          {" "}
                          ₺
                          {this.props.cart.items.length > 0
                            ? parseFloat(
                                this.props.cart.items
                                  .map((v) =>
                                    v.sale_price
                                      ? v.quantity * v.sale_price
                                      : v.quantity * v.price
                                  )
                                  .reduce((a, b) => a + b)
                                  .toFixed(2)
                              )
                            : 0}
                        </span>
                      </li>
                    </ul>
                    <div className={"text-right"}>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (this.props.customer.customer) {
                            alert("Giriş Yapmış");
                          } else {
                            this.props.history.push({
                              pathname: "/odeme/giris",
                              state: {},
                            });
                          }
                        }}
                        type={"button"}
                      >
                        Alışverişi Tamamla
                      </button>
                    </div>
                  </div>
                </Widget> 
                 <CategoriesWidget /> 
              </div> */}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, cart, customer, order, page }) => {
  return { cart, customer, order, page, setting };
};

const mapDispatchToProps = {
  createNewOrderForCustomer,
  customerGetAddress,
  removeCart,
  incCart,
  decCart,
  updateCartQuantity,
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/routers/Checkout/index.js